<template>
  <div class="news">
    <div class="banner">
      <img src="../../assets/img/news/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("news.banner.bannerTitle")}}</h1>
          <p>{{$t("news.banner.bannerP")}}</p>
        </div>
      </div>
    </div>

    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in newsTabs" :key="index" :label="language=='cn' ? item.dictLabel : language=='en'?item.cssClass : item.remark " :name="item.name">
          <component :is="item.name"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import tab1 from './latestNews'
import tab2 from './mediaReport'
import tab3 from './enterprisePublicity'
import {by_typename} from "../../api/news"
import { mapGetters } from "vuex";
export default {
  name: "News",
  data() {
    return {
      activeName: "tab1",
      newsTabs:[],
    };
  },
  computed:{
    ...mapGetters(['language'])
  },
  mounted() {
    const partId=this.$route.query.part;

    if(partId){
      this.$nextTick(()=>{
        this.activeName= partId;
      })
    }
    
    by_typename(this.language,{dictType:'dqgx_new_type'}).then(res=>{

      res.data.forEach(item => {
        item.name="tab"+item.dictValue
      });
      // 媒体报道隐藏
      // res.data.splice(1,1);
      this.newsTabs= res.data.slice(0,3);;

    });
    
  },
  watch:{
    $route(val){
      this.activeName= val.query.part;
    }
  },
  components:{tab1,tab2,tab3},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
   
  }
};
</script>
<style lang="scss" scoped>
$cblue: #0054a7;
.news {
  .el-tabs {
    padding-top: 20px;
    ::v-deep .el-tabs__active-bar {
      width: 36px;
    }
    ::v-deep .el-tabs__item {
      font-size: 18px;
    }
    .headline {
        padding: 40px 0;
    }

  }
}
</style>